import { render, staticRenderFns } from "./LoginImage.vue?vue&type=template&id=2ac9ccc6&"
import script from "./LoginImage.vue?vue&type=script&lang=js&"
export * from "./LoginImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports